import { render } from "./PageTestimoni.vue?vue&type=template&id=3539b706"
import script from "./PageTestimoni.vue?vue&type=script&lang=js"
export * from "./PageTestimoni.vue?vue&type=script&lang=js"

import "./PageTestimoni.vue?vue&type=style&index=0&id=3539b706&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__